// extracted by mini-css-extract-plugin
module.exports = {"infoTable":"InfoTable_infoTable__2jciu","infoIcon":"InfoTable_infoIcon__3LSHL","text":"InfoTable_text__3yhiK"};